module.exports = __webpack_public_path__ + "static/media/arrowupwardGreen.8813383f.svg";